import React from 'react';

/* Premiere Pro's app mark: lavender "Pr" on deep navy. Matches the landing page. */
const PremiereLogo = ({ className = 'h-8 w-8', style }) => (
  <svg
    viewBox="0 0 240 234"
    className={className}
    style={{ textTransform: 'none', letterSpacing: 0, flexShrink: 0, ...style }}
    role="img"
    aria-label="Adobe Premiere Pro"
  >
    <rect x="5" y="5" width="230" height="224" rx="42" fill="#00005b" stroke="#9999ff" strokeWidth="10" />
    <text
      x="120"
      y="158"
      textAnchor="middle"
      fill="#9999ff"
      fontFamily="'Source Sans 3', 'Myriad Pro', 'Helvetica Neue', Arial, sans-serif"
      fontSize="132"
      fontWeight="700"
      letterSpacing="-4"
      direction="ltr"
    >
      Pr
    </text>
  </svg>
);

export default PremiereLogo;
